import { getAccountData } from "../../Functions/account-data/get-account-data.js";

class identifyCNPJCategory {
  static async getCategory(cnpj) {
    const { category } = await identifyCNPJCategory.getCategoryAndName(cnpj);
    return category;
  }

  static async getCategoryAndName(cnpj) {
    const referencial = await getAccountData(cnpj);
    let category = false;
    if (
      !referencial.tipo ||
      referencial.tipo.includes("REDE") ||
      referencial.tipo.includes("BALCONISTA") ||
      referencial.tipo.includes("OTICA") ||
      referencial.tipo.includes("FORNECEDOR") ||
      referencial.tipo.includes("CONSUMIDORES") ||
      referencial.tipo.includes("DISTRIBUIDOR")
    ) {
      category = "OTICA";
    } else if (referencial.tipo === "AFILIADOS" || referencial.tipo.includes("EMPREGADOS")) {
      category = "ESSILOR";
    } else if (referencial.tipo.includes("LAB PARTICIPACAO")) {
      category = "LABORATORIO";
    } else if (referencial.tipo.includes("LAB ALLIANCE") || referencial.tipo.includes("LABORATORIOS")) {
      category = "LAB_INDEPENDENTE";
    } else if (referencial.tipo.includes("MEDICO") || referencial.tipo.includes("CLINICAS")) {
      category = "MEDICO";
    }
    return { category, nome: referencial.nome };
  }
}

export default identifyCNPJCategory;
